import * as R from 'ramda'
import { tenants, owners, properties, leases, payments, credits } from './entities'
import { transactionsEx, paymentsByPartyID } from './transactions'
import createSelector from 'utils/redux/createSelector' // import { createSelector } from 'reselect'
import { filter, doc, makePropSelector, currentDate } from './common'
import moment from 'moment'
import breakdown from 'helpers/kpi/breakdown'


let attachments = state => state.attachments

export let property = (state) => (id) => {
	let property = properties(state)[id]
	if(!property) return undefined
	return({
		...property
	  , landlord: owners(state)[property.owner]
	  , tenants: (property.leaseID && leases(state)[property.leaseID] && R.keys(tenants(state)).length)?
	  		R.filter(tenant =>
					(leases(state)[property.leaseID].tenantsIDs)?
						leases(state)[property.leaseID].tenantsIDs.indexOf(tenant._id) != -1
					: false
					, R.values(tenants(state))
				)
				: undefined
	  , leaseEnd: (property.leaseID && leases(state)[property.leaseID])? leases(state)[property.leaseID].end : undefined
	  , comments: (property.comments)?R.map(
			commentData =>({
				...commentData
			  , attachments: (commentData.attachmentsIDs)?
					R.map(
						attachmentID =>
							(attachments(state)[property._id]
							&& attachments(state)[property._id].attachments[attachmentID.id])?
								attachments(state)[property._id].attachments[attachmentID.id]
								: false
						, commentData.attachmentsIDs
					)
					:{}
			})
			, property.comments)
			: []
	})
}

export let transactionsByPropertyID = createSelector(transactionsEx, R.pipe(R.values, R.groupBy(R.prop('propertyID'))))

export let checkTransactions = createSelector(
	[transactionsByPropertyID, payments, credits, currentDate, properties]
  , (transactionsByPropertyID, payments, credits, currentDate, properties) => {

		return R.map(property=>{
			let propertyID = property._id

			let invoicesByPartyID = R.pipe(R.values, R.filter(x => x.type == "transaction/invoice"), R.groupBy(R.prop('partyID')))(transactionsByPropertyID[propertyID] || [])
			let paymentsByPartyID = R.pipe(R.values, R.filter(x => x.propertyID == propertyID), R.groupBy(R.prop('partyID')))({...payments, ...credits} || {})

			let invoices = R.mapObjIndexed((partyInvoices, partyID) => {
				let sortedInvoices = R.pipe(R.values, R.sortBy(x => moment(x.date)))(partyInvoices || [])
				let sortedPayments = R.pipe(R.values, R.sortBy(x => moment(x.date)))(paymentsByPartyID[partyID] || [])
				let paymentsAmounts = R.map(x => x.amount)(sortedPayments)
				let i = 0
				return R.map(invoice => {
					let invoiceAmount = invoice.amount
					let index
					if(i<paymentsAmounts.length) do{
						index = i
						let paymentAmount = paymentsAmounts[i] - invoiceAmount > 0 ? paymentsAmounts[i] - invoiceAmount : 0
						invoiceAmount -= (paymentsAmounts[i] - paymentAmount)
						paymentsAmounts[i] = paymentAmount
						if(paymentsAmounts[i] <= 0 && i<paymentsAmounts.length-1) {
							i++
						} else {
							break
						}
					}while(invoiceAmount > 0 || paymentsAmounts.length != i+1)

                    let lastPayment = sortedPayments[index] || {}
					if(invoiceAmount == 0 && moment(lastPayment.date) <= moment(invoice.dueDate)){
							return {...invoice, lastPayment: lastPayment.date}
					} else if (invoiceAmount != 0) {
							if(invoiceAmount === invoice.amount){
								return {...invoice, lastPayment: i && lastPayment.date || undefined, unpaid: true}
							} else {
								return {...invoice, lastPayment: i && lastPayment.date || undefined, partialPayment: true}
							}
					} else if(invoiceAmount == 0 && moment(lastPayment.date) > moment(invoice.dueDate)){
						return {...invoice, lastPayment: lastPayment.date, late: true}
                    }
                    return invoice
				})(sortedInvoices)
			})(invoicesByPartyID)

			invoices = R.pipe(R.values, R.reduce((acc, next) => acc.concat(next), []))(invoices)

			let unPaid = R.filter(invoice => invoice && (invoice.unpaid || invoice.partialPayment) && (moment(new Date(invoice.dueDate)).format('YYYY-MM-DD') <= moment(new Date(currentDate)).format('YYYY-MM-DD')), invoices || [])
			let latePaid= R.filter(invoice => invoice && invoice.late)(invoices || [])
			let paid = R.filter(invoice => invoice && !invoice.unpaid && !invoice.late && !invoice.partialPayment)(invoices || [])
			let transactions = {unPaid, latePaid, paid}

			//
			return transactions
		}, properties)
	}
  , 'checkTransactions'
)

//TODO check propertyLoan
export let propertyLoan = createSelector(
	[properties, makePropSelector('propertyID')]
  , (properties, propertyID) => {
		let currBreakdown = breakdown(properties, moment().format('YYYY-MM-DD'))[propertyID]
		return {
			monthlyPayment: currBreakdown.payment
		  , principalLeft: currBreakdown.balance.toFixed(2)
		}
	}
)



// WEBPACK FOOTER //
// ./src/selectors/property.js